(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.pdvDfInit === '1') return;
    root.dataset.pdvDfInit = '1';

    initDose(root);
    initCarousel(root);
    initMarquee(root);
  }

  function initDose(root) {
    var dose = root.querySelector('[data-pdv-dose]');
    if (!dose) return;

    if (dose.getAttribute('data-animate') !== 'true') {
      dose.classList.add('is-inview');
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      dose.classList.add('is-inview');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      dose.classList.add('is-inview');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          dose.classList.add('is-inview');
          observer.disconnect();
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(dose);
  }

  function initCarousel(root) {
    var viewport = root.querySelector('[data-pdv-cards-viewport]');
    var track = root.querySelector('[data-pdv-cards-track]');
    var prevBtn = root.querySelector('[data-pdv-prev]');
    var nextBtn = root.querySelector('[data-pdv-next]');
    var dotsEl = root.querySelector('[data-pdv-dots]');
    if (!viewport || !track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-pdv-card]'));
    if (!cards.length) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      if (dotsEl) dotsEl.hidden = true;
      return;
    }

    var page = 0;
    var pages = 1;
    var perPage = 4;

    function getPerPage() {
      var w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 989) return 2;
      return 4;
    }

    function isMobilePeekScroll() {
      return window.innerWidth <= 749;
    }

    function measure() {
      perPage = getPerPage();
      pages = Math.max(1, Math.ceil(cards.length / perPage));
      if (page > pages - 1) page = pages - 1;

      if (isMobilePeekScroll()) {
        track.style.transform = '';
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        if (dotsEl) dotsEl.hidden = true;
        return;
      }

      renderDots();
      goTo(page, false);
    }

    function renderDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      if (pages <= 1 || isMobilePeekScroll()) {
        dotsEl.hidden = true;
        return;
      }
      dotsEl.hidden = false;
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdv-df__dot' + (i === page ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        btn.setAttribute('aria-current', i === page ? 'true' : 'false');
        (function (index) {
          btn.addEventListener('click', function () {
            goTo(index, true);
          });
        })(i);
        dotsEl.appendChild(btn);
      }
    }

    function goTo(index, animate) {
      if (isMobilePeekScroll()) return;

      page = Math.max(0, Math.min(pages - 1, index));
      var gap = parseFloat(window.getComputedStyle(track).gap) || 16;
      var cardWidth = cards[0].getBoundingClientRect().width;
      var offset = page * perPage * (cardWidth + gap);
      if (!animate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      track.style.transform = 'translateX(-' + offset + 'px)';
      if (!animate) {
        void track.offsetWidth;
        track.style.transition = '';
      }
      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= pages - 1;
      if (dotsEl) {
        var dots = dotsEl.querySelectorAll('.pdv-df__dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === page);
          dots[i].setAttribute('aria-current', i === page ? 'true' : 'false');
        }
      }
      var showNav = pages > 1;
      if (prevBtn) prevBtn.hidden = !showNav;
      if (nextBtn) nextBtn.hidden = !showNav;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(page - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(page + 1, true);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 120);
    });

    measure();
  }

  function initMarquee(root) {
    var marquee = root.querySelector('[data-pdv-marquee]');
    if (!marquee) return;

    var trackWrap = marquee.querySelector('.pdv-df__marquee-wrap');
    var sourceTrack = marquee.querySelector('[data-pdv-marquee-source]');
    if (!trackWrap || !sourceTrack) return;

    var resizeFrame = null;

    function rebuild() {
      resizeFrame = null;
      trackWrap.classList.remove('is-ready');
      trackWrap.querySelectorAll('[data-pdv-marquee-clone]').forEach(function (clone) {
        clone.remove();
      });

      var sourceWidth = sourceTrack.getBoundingClientRect().width;
      var wrapStyles = window.getComputedStyle(trackWrap);
      var gap = parseFloat(wrapStyles.columnGap) || 0;
      var cycleWidth = sourceWidth + gap;

      if (sourceWidth === 0 || cycleWidth === 0) return;

      var requiredWidth = marquee.clientWidth + cycleWidth;
      var renderedWidth = sourceWidth;

      while (renderedWidth < requiredWidth) {
        var clone = sourceTrack.cloneNode(true);
        clone.removeAttribute('data-pdv-marquee-source');
        clone.setAttribute('data-pdv-marquee-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (block) {
          block.removeAttribute('data-shopify-editor-block');
        });
        trackWrap.appendChild(clone);
        renderedWidth += cycleWidth;
      }

      trackWrap.style.setProperty('--pdv-df-marquee-cycle', cycleWidth + 'px');
      trackWrap.classList.add('is-ready');
    }

    function queueRebuild() {
      if (resizeFrame !== null) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(rebuild);
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(queueRebuild);
      resizeObserver.observe(marquee);
      resizeObserver.observe(sourceTrack);
    } else {
      window.addEventListener('resize', queueRebuild);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(queueRebuild);
    }

    queueRebuild();
  }

  function boot() {
    document.querySelectorAll('[data-pdv-df]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pdv-df]');
    if (root) {
      delete root.dataset.pdvDfInit;
      initSection(root);
    }
  });
})();
